import { getJson, putJson, postJson } from '../../utils/network';
import { networkProgress, networkFailed, resetNetwork } from '../../actions';
import { trackEvent, EDIT_CONTACT_DETAILS, EDIT_ADDRESSES, SUCCESS } from '../../utils/analytics';

export const GET_CUSTOMER = 'GET_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const GET_CUSTOMER_TASKS = 'GET_CUSTOMER_TASKS';

function getCustomerTasksSuccess(data) {
    return {
        type: GET_CUSTOMER_TASKS,
        tasks: data
    }
}

function getCustomerSuccess(data) {
    return {
        type: GET_CUSTOMER,
        customer: data
    };
}

function updateCustomerSuccess(data) {
   return {
      type: UPDATE_CUSTOMER,
      customer: data
   };
}

export function getCustomerTasks() {
    return dispatch => {
        dispatch(networkProgress());
        return getJson('customerTasks')
            .then(response => {
                dispatch(getCustomerTasksSuccess(response.data));
                dispatch(resetNetwork());
            })
            .catch(error => {
                dispatch(networkFailed(error));
            })
    }
}

export function updateAddresses(data) {
    return dispatch => {
        dispatch(networkProgress());
        return postJson('/customer', data)
            .then(response => {
                dispatch(getCustomerTasks());
                trackEvent(EDIT_ADDRESSES, SUCCESS);
                dispatch(resetNetwork());
            })
            .catch(error => {
                dispatch(networkFailed(error));
            })
    }
}

export function updateCustomer(data) {
   return dispatch => {
      dispatch(networkProgress());
      return putJson('/customer', data)
         .then(response => {
            dispatch(updateCustomerSuccess(response.data));
            trackEvent(EDIT_CONTACT_DETAILS, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         })
   }
}

export function getCustomer() {
    return dispatch => {
        dispatch(networkProgress());
        return getJson('/customer')
            .then(response => {
                dispatch(getCustomerSuccess(response.data));
                dispatch(getCustomerTasks());
                dispatch(resetNetwork());
            })
            .catch(error => {
                dispatch(networkFailed(error));
            });
    };
}